import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, Subscription } from 'rxjs';
import {
  RecentPerformanceModel,
  ProblemRecentPerformanceModel,
  ProblemModel,
  StudentExercisePerformanceModel
} from '@generativ/much-smarter-models';
import { StudentService } from '../student.service';
import { UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormService } from '../../../core/services/form.service';
import { NgbAccordionDirective, NgbAccordionItem, NgbAccordionHeader, NgbAccordionToggle, NgbAccordionButton, NgbAccordionCollapse, NgbAccordionBody } from '@ng-bootstrap/ng-bootstrap/accordion';
import { NgbCollapse } from '@ng-bootstrap/ng-bootstrap/collapse';
import { SpinnerComponent } from '../../../shared/spinner/spinner.component';
import { ContentViewerComponent } from '../../../shared/content-viewer/content-viewer.component';
import { AsyncPipe } from '@angular/common';
import { PaginationHelperPipe } from '../../../shared/pipes/pagination-helper.pipe';
import { TimePipe } from '../../../shared/pipes/time.pipe';

@Component({
    selector: 'app-history',
    templateUrl: './history.component.html',
    styleUrls: ['./history.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, ReactiveFormsModule, NgbAccordionDirective, NgbAccordionItem, NgbAccordionHeader, NgbAccordionToggle, NgbAccordionButton, NgbCollapse, NgbAccordionCollapse, NgbAccordionBody, SpinnerComponent, ContentViewerComponent, AsyncPipe, PaginationHelperPipe, TimePipe]
})
export class HistoryComponent implements OnInit, OnDestroy {
  subscriptions: Subscription = new Subscription();
  recentPerformanceObservable: Observable<RecentPerformanceModel>;
  // limit 5 exercise performance per page.
  limit = 5;

  performanceControl: UntypedFormGroup;
  selectedProblemPerformance: ProblemRecentPerformanceModel;
  selectedProblem: ProblemModel;

  exercisePerformanceMetrics: Map<number, StudentExercisePerformanceModel>;

  constructor(private modalService: NgbModal,
              private studentService: StudentService,
              private formService: FormService) {
    this.performanceControl = this.formService.createForm(this.formOptions);
  }

  ngOnInit() {
    this.getExercisePerformance();
    this.recentPerformanceObservable = this.getRecentPerformance(this.performanceControl.value);

    // Subscribe to change in any of the controls we should call the api again.
    this.subscriptions.add(this.performanceControl.valueChanges.subscribe((nextValue) => {
      this.recentPerformanceObservable = this.getRecentPerformance(nextValue);
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  openProblemModal(content, problemPerformance: ProblemRecentPerformanceModel) {
    this.selectedProblemPerformance = problemPerformance;
    this.subscriptions.add(this.studentService.getProblem(problemPerformance.problemId).subscribe((problem) => {
      console.log(problem);
      this.selectedProblem = problem;
      this.modalService.open(content, { windowClass: 'help-modal' });
    }, () => {
      // TODO: Show error message that couldn't load problem
    }));

  }

  /**
   * Call api to get the get Recent performance with the filters.
   *
   * @param value
   */
  getRecentPerformance(value): Observable<RecentPerformanceModel> {
    // Offset will be the page we are minus one. Since the form value has the one minus the value
    // that we are showing in the html it can be calculated:
    const offset = (+value.page) * this.limit;
    const subject = value.subject === 'All' ? null : value.subject;

    return this.studentService.getRecentPerformance(
      subject,
      value.onlyIncorrect,
      value.flagged,
      offset,
      this.limit);
  }

  getExercisePerformance() {
    this.subscriptions.add(this.studentService.getExercisePerformance()
      .subscribe((result: { keys: number[]; values: StudentExercisePerformanceModel[] }) => {
        this.exercisePerformanceMetrics = new Map<number, StudentExercisePerformanceModel>();
        if (result && result.hasOwnProperty('keys')) {
          for (let i = 0; i < result.keys.length; ++i) {
            this.exercisePerformanceMetrics.set(result.keys[i], result.values[i]);
          }
        }
      }));
  }

  private get formOptions(): Record<string, unknown> {
    return {
      subject: ['All'],
      onlyIncorrect: [false],
      flagged: [false],
      page: [0]
    };
  }

}
